import { OrchestrationTopics } from "./FilterTypes";
import { EventHistoryTopics } from "./EventHistory";
import { events } from "@otto-ec/global-resources/event-q-bus";

export type Topics = EventHistoryTopics & OrchestrationTopics;

export const eventQBus = events<Topics>();
